import Vue from 'vue';
import Vuex from 'vuex'

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;

             localStorage.setItem("userInfo", user);
            console.log("存储了userinfo" +user)
        },
        // 退出
        logout(state, user) {
            state.user = "";
         // localStorage.removeItem('userInfo');
            localStorage.setItem("userInfo", "");
          console.log("移除了userinfo")
        }
    }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js